import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { useIsTextTruncated } from '../../../../../../../components/v2/form/_components/ChipList/hooks/useIsTextTruncated';

interface CatalogCardNameProps {
  name: string;
}

const CatalogCardName = ({ name }: CatalogCardNameProps) => {
  const { setElement, isTruncated } = useIsTextTruncated<HTMLElement>();

  return (
    <Tooltip tabIndex={-1} TooltipContent={name} disabled={!isTruncated}>
      <Typography
        noWrap
        ref={setElement}
        variant="subtitle2"
        sx={{ minWidth: 0, fontWeight: 'fontWeightMedium' }}
      >
        {name}
      </Typography>
    </Tooltip>
  );
};

export default CatalogCardName;
